export class NICEDialerRetrySettings {
    loadNonFresh: boolean;
    finalizeWhenExhausted: boolean;
    maximumAttempts: number;
    minimumRetryMinutes: number;
    maximumNumberOfHandledCalls: number;
    restrictedCallingMinutes: number;
    restrictedCallingMaxAttempts: number;
    generalStaleMinutes: number;
    callbackRestMinutes: number;
    releaseAgentSpecificCalls: boolean;
    maximumNumberOfCallbacks: number;
    callbackStaleMinutes: number;

    constructor(jsonObject?) {

        this.loadNonFresh = jsonObject?.loadNonFresh || false;
        this.finalizeWhenExhausted = jsonObject?.finalizeWhenExhausted || false;
        this.releaseAgentSpecificCalls = jsonObject?.releaseAgentSpecificCalls || false;
        this.maximumAttempts = jsonObject?.maximumAttempts || 0;
        this.minimumRetryMinutes = jsonObject?.minimumRetryMinutes || 0;
        this.maximumNumberOfHandledCalls = jsonObject?.maximumNumberOfHandledCalls || 0;
        this.restrictedCallingMinutes = jsonObject?.restrictedCallingMinutes || 0;
        this.restrictedCallingMaxAttempts = jsonObject?.restrictedCallingMaxAttempts || 0;
        this.generalStaleMinutes = jsonObject?.generalStaleMinutes || 0;
        this.callbackRestMinutes = jsonObject?.callbackRestMinutes || 0;
        this.maximumNumberOfCallbacks = jsonObject?.maximumNumberOfCallbacks || 0;
        this.callbackStaleMinutes = jsonObject?.callbackStaleMinutes || 0;

    }
}
